<template>
  <div id="classReportPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="گزارش کلاسی"></ActionBar>
    <div class="row container mx-auto p-0  mt-2">
      <div class="col-12 mx-auto p-0">
        <div class="card-shadow round10px bg-white p-2 my-2 card-top-line">
          <div class="mt-3 font-weight-bold"><img :src="getImgUrl('file-report.png')" alt="پرونده"
                                                  class="img-fluid pl-1"> گزارش کلاسی
          </div>
          <div class="row mt-2">
            <div class="col-12 pb-0 col-md-4 col-lg-3">
              <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب درس:</span></div>
              <div>
                <v-autocomplete
                    v-model="classSelectedID"
                    :items="classes"
                    class="input-border"
                    dense
                    hide-details
                    item-text="Name"
                    item-value="LessonsFunID"
                    solo>
                </v-autocomplete>
              </div>
            </div>
            <div class="col-8 col-md-4 col-lg-3">
              <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب روز:</span></div>
              <div>
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-left="0"
                    min-width="auto"
                    offset-y
                    transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="inputDate"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        class="input-border"
                        dense
                        hide-details
                        readonly
                        solo></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="date"
                      locale="fa-ir"
                      width="206"
                      @input="inputDatePicker"></v-date-picker>
                </v-menu>
              </div>
            </div>
            <div class="col-4  col-md-4 col-lg-3 align-self-end text-center">
              <v-btn :disabled="classSelectedID === null" color="forth" rounded @click="searchReport">
                <span class="white--text">جستجو</span>
              </v-btn>
            </div>
          </div>
          <div v-if="dataLoading" class="col-12 mt-10 col-md-6 col-lg-3 mx-auto text-center">
            در حال جستجو
            <v-progress-linear
                color="deep-purple accent-4"
                height="6"
                indeterminate
                rounded
            ></v-progress-linear>
          </div>
          <div v-else-if="isLoaded">
            <div v-if="!hasData" class="mt-8">
              <v-alert
                  border="bottom"
                  class="mt-4 text-center"
                  color="primary"
                  dark>
                <span class="font12px">با توجه به موارد انتخاب شده کلاسی برگزار نشده است.</span>
              </v-alert>
            </div>
            <div v-else>
              <div v-if="reportData.Description === null && reportData.FileUrl === null" class="mt-8">
                <v-alert
                    border="bottom"
                    class="mt-4 text-center"
                    color="forth"
                    dark>
                  <span class="font12px">برای این درس گزارشی ثبت نشده است.</span>
                </v-alert>
              </div>
              <div v-else>
                <div class="mt-8"><i class="fas fa-pen pl-1"></i><span class=" font-weight-bold">گزارش دبیر:</span>
                </div>
                <div class=" font12px pr-5">{{ reportData.Description }}</div>
                <v-btn v-if="reportData.FileUrl !== null" class="mt-3 white--text" color="black" rounded small
                       @click="downloadFile(reportData.FileUrl)">
                  <i class="fas fa-download ml-2 pb-1"></i>
                  <span class="font12px">دانلود فایل</span>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <FooterMenu :currentPage="'classReport'"/>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";
import moment from "moment-jalaali";

export default {
  name: "ClassReport",
  metaInfo: {
    title: 'مسیربرتر-گزارش کلاسی'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    text: 'لورم ایپسوم یا طرح‌نما (به انگلیسی: Lorem ipsum) به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده استفاده می نماید، تا از نظر گرافیکی نشانگر چگونگی نوع و اندازه فونت و ظاهر متن باشد. معمولا طراحان گرافیک برای صفحه‌آرایی، نخست از متن‌های آزمایشی و بی‌معنی استفاده می‌کنند تا صرفا به مشتری یا صاحب کار خود نشان دهند که صفحه طراحی یا صفحه بندی شده بعد از اینکه متن در آن قرار گیرد چگونه به نظر می‌رسد و قلم‌ها و اندازه‌بندی‌ها چگونه در نظر گرفته شده‌است..',
    inputDate: '',
    menu: false,
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    classes: [],
    classSelectedID: null,
    startDate: null,
    endDate: null,
    dataLoading: false,
    hasData: false,
    reportData: null,
    isLoaded: false

  }),
  mounted() {
    _this = this;
    this.getData()
  },

  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CurrentLessonManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result).LessonsFuns
            _this.classes = json.filter(x => x.LessonsFunID !== null)
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    inputDatePicker() {
      this.menu = false
      this.inputDate = moment(this.date).format('jYYYY/jMM/jDD')
    },
    searchReport() {
      this.dataLoading = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CurrentLessonManagement/_List?EndTime=" + new Date(this.date).toISOString().slice(0, 10) + "T23:00:00.00+&StartDate=" + new Date(this.date).toISOString().slice(0, 10) + "T00:00:00.00+&LessonsFunID=" + this.classSelectedID, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            _this.isLoaded = true
            if (json.list.length === 0) {
              _this.hasData = false
            } else {
              _this.hasData = true
              _this.reportData = (json.list)[0]
            }
            _this.dataLoading = false
          })
          .catch(error => console.log('error', error));
    },
    downloadFile(link) {
      this.$openLink(link)
    }
  }
}
</script>

<style scoped>

</style>